import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type { Address } from '@primitives/address.utils'
import { SizesAndSpaces } from '@ui/features/themes/design/1_sizes_spaces'
import { Cross2Icon } from '@ui/icons/Cross2Icon'
import { LlamaImg } from '@ui/images'

const { Spacing } = SizesAndSpaces

type Props = { userAddress: Address | undefined; addressLabel: string | undefined; onClose: () => void }

/** Gap deviates from Figma as personally 'xs' is too narrow. */
export const UserProfileHeader = ({ userAddress, addressLabel, onClose }: Props) => (
  <Stack direction="row" sx={{ alignItems: 'center', gap: Spacing.sm }}>
    {userAddress && (
      <>
        <Box component="img" src={LlamaImg} sx={{ height: SizesAndSpaces.IconSize.xl }} alt="Llama Icon" />

        <Typography variant="headingMLight" sx={{ flexGrow: 1 }}>
          {addressLabel}
        </Typography>
      </>
    )}

    <Stack direction="row" sx={{ ...(!userAddress && { flexGrow: 1 }), justifyContent: 'end' }}>
      <IconButton size="small" onClick={onClose}>
        <Cross2Icon />
      </IconButton>
    </Stack>
  </Stack>
)
